import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchMainSliderAPI } from "./mainSliderAPI";

export const fetchMainSliderData = createAsyncThunk(
    "home/fetchMainSliderData",
    async () => {
        const data = await fetchMainSliderAPI();
        return data
    }
)

const mainSliderSlice = createSlice({
    name: "main_slider",
    initialState: {
        sliders: {},
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchMainSliderData.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchMainSliderData.fulfilled, (state, action) => {
            state.loading = false;

            state.sliders = action.payload.data || {};
        })
        .addCase(fetchMainSliderData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default mainSliderSlice.reducer;